import { css } from 'emotion';
import { Link } from 'react-router-dom';
import styled from 'react-emotion';

import Style from '../../styles/common';

export const Group = styled('article')`
  margin-bottom: 3rem;
`;

export const H1 = styled('h1')`
  font-size: ${Style.FONT_SIZE.XXL};
`;

export const H2 = styled('h2')`
  font-size: ${Style.FONT_SIZE.XL};
`;

export const H3 = styled('h3')`
  font-size: ${Style.FONT_SIZE.L};
`;

export const Paragraph = styled('p')`
  font-size: 0.9rem;
  line-height: 1.75;
`;

const linkStyles = css`
  color: ${Style.color.LINK};
`;

export const Hyperlink = styled('a')`
  ${linkStyles};
`;

export const RouterLink = styled(Link)`
  ${linkStyles};
`;



// WEBPACK FOOTER //
// ./src/components/Text/Text.js